import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ScrollAreaScrollbarProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { ScrollAreaScrollbar, ScrollAreaThumb } from "reka-ui"
import { cn } from "@/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollBar',
  props: {
    orientation: { default: "vertical" },
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, "class")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ScrollAreaScrollbar), _mergeProps({ "data-slot": "scroll-area-scrollbar" }, _unref(delegatedProps), {
    class: 
      _unref(cn)('flex touch-none p-px transition-colors select-none',
         __props.orientation === 'vertical'
           && 'h-full w-2.5 border-l border-l-transparent',
         __props.orientation === 'horizontal'
           && 'h-2.5 flex-col border-t border-t-transparent',
         props.class)
  }), {
    default: _withCtx(() => [
      _createVNode(_unref(ScrollAreaThumb), {
        "data-slot": "scroll-area-thumb",
        class: "bg-border relative flex-1 rounded-full"
      })
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})